import React from "react"
import { Table } from "antd"
import "antd/lib/table/style/css"
import DataShop from "../../../data/shop"
import Pie from "../../../components/charts/pie"
import Sex from "../../../components/charts/sex"
import Util from "../../../util/util"

import "./UserProfile.less"
let ageNames = [
  "18岁以下",
  "19-24岁",
  "25-34岁",
  "35-44岁",
  "45-54岁",
  "55岁以上",
]

// 基础画像
class UserProfile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      list: [],
      pagination: { pageSize: Util.isMobile ? 10 : 15 },
      loading: true,
    }
    this.columns = [
      {
        title: "Mac",
        dataIndex: "mac",
        sorter: (a, b) =>
          parseInt(a.mac.replace(":", ""), 16) -
          parseInt(b.mac.replace(":", ""), 16),
        width: "25%",
      },
      {
        title: "男/女",
        dataIndex: "gender",
        width: 100,
      },
    ]
    this.changePage = this.changePage.bind(this)
  }
  componentDidMount() {
    this.getData(1)
  }
  getData(pn) {
    let { id, date } = this.props
    let pager = { ...this.state.pagination }
    this.setState({ loading: true })
    DataShop.getUserProfile(id, date, pn - 1, pager.pageSize).then((res) => {
      let data = res.data
      let { c_name, category = [], gender, age } = data
      if (c_name && this.columns.length === 2) {
        data.c_name.forEach((name, i) => {
          this.columns.push({
            title: name,
            dataIndex: "type_" + i,
            width: 100,
          })
        })
      }

      let list = category.map((item) => {
        item.type.forEach((t, i) => {
          item["type_" + i] = t
        })
        return item
      })
      pager.current = pn
      pager.total = data.total_record
      this.setState({
        c_name,
        list: list,
        pagination: pager,
        loading: false,
        gender,
        age:
          age &&
          age.map((a, i) => {
            return {
              name: ageNames[i],
              value: a,
            }
          }),
      })
    })
  }

  changePage(pagination) {
    this.getData(pagination.current)
  }

  render() {
    let { c_name, list, pagination, loading, gender, age } = this.state
    return (
      <div className="box-user-profile">
        {c_name ? (
          <div>
            <h2 className="shop-body-title">
              <i className="icon" />
              <span className="i-title">基础画像</span>
            </h2>
            <div className="table-box">
              <Table
                columns={this.columns}
                dataSource={list}
                pagination={pagination}
                loading={loading}
                onChange={this.changePage}
                rowKey="mac"
              />
            </div>
          </div>
        ) : null}
        {gender ? (
          <div className="sex-container">
            <h2 className="p-sex shop-body-title">
              <i className="icon" />
              <span className="i-title">性别分布</span>
            </h2>
            <div className="sexBox ">
              <Sex values={[gender.male, gender.female]} />
            </div>
          </div>
        ) : null}
        {age ? (
          <div>
            <h2 className="visit-h2 shop-body-title">
              <i className="icon" />
              <span className="i-title">年龄分部</span>
            </h2>
            <div id="customerTypePie" className="bottom-line">
              <Pie conf={{ title: "", list: age, unit: "" }} />
            </div>
          </div>
        ) : null}
      </div>
    )
  }
}

export default UserProfile
